import moment from 'moment';
import roles from '@/utils/roles';

const getDistributorManageDocuments = distributor => {
    if (!distributor) return false;

    const distributorsTypeThatManageDocuments = [
        'COMERCIALIZADOR',
        'COMERCIALIZADOR_PP',
        'COMERCIALIZADOR_FI'
    ];

    return distributorsTypeThatManageDocuments.includes(distributor.distributor_type);
};

const getDistributorIsComercializadoraPP = distributor => {
    if (!distributor) return false;

    return distributor.distributor_type === 'COMERCIALIZADOR_PP';
};

const isMinor = entity => {
    if (!entity.birthdate) return false;

    return moment().diff(entity.birthdate, 'years') < 18;
};

// El de conveniencia sólo se pide a FISICAS, NO a JURIDICAS NI A ASOCIADOS/PATRONOS
const getEntityNeedConvenienceTest = async (entity, account) => {
    if (!entity || !account) return false;
    if (!entity.birthdate) return false;

    const distributor = account.distributor || account.distributor_data;
    const distributorManageDocuments = getDistributorManageDocuments(distributor);
    const distributorIsComercializadoraPP = getDistributorIsComercializadoraPP(distributor);

    const accountType = account.account_type || account.account_data.account_type;
    // Para Plones, no se pide test de conveniencia a nadie
    if (accountType === 'P') {
        return [];
    }

    if (distributorManageDocuments) {
        if (!distributorIsComercializadoraPP) {
            return [];
        }
    }

    const rolesNeedConvenience = await roles.getRolesNeedConvenience();

    const entityNeedConvenienceTest =
        !isMinor(entity) &&
        entity.intervener_type &&
        entity.intervener_type === 'F' &&
        roles.hasEntitySomeRole(entity, rolesNeedConvenience);

    return entityNeedConvenienceTest;
};

const getEntityNeedKYCOrFatcaCrs = async (entity, account) => {
    const entityNeedKYCOrFatcaCrs = {
        needKYC: false,
        needFatcaCrs: false
    };

    if (!entity || !account) return entityNeedKYCOrFatcaCrs;

    const distributor = account.distributor || account.distributor_data;
    const distributorManageDocuments = getDistributorManageDocuments(distributor);
    const distributorIsComercializadoraPP = getDistributorIsComercializadoraPP(distributor);

    if (distributorManageDocuments) {
        if (!distributorIsComercializadoraPP) {
            return entityNeedKYCOrFatcaCrs;
        } else if (account.account_type === 'P') {
            return entityNeedKYCOrFatcaCrs;
        }
    }

    const rolesNeedKyc = await roles.getRolesNeedKyc();
    entityNeedKYCOrFatcaCrs.needKYC = roles.hasEntitySomeRole(entity, rolesNeedKyc);

    if (entity.intervener_type !== 'J') {
        const rolesNeedFatcaCrs = await roles.getRolesNeedFatcaCrs();
        entityNeedKYCOrFatcaCrs.needFatcaCrs = roles.hasEntitySomeRole(entity, rolesNeedFatcaCrs);
    }

    return entityNeedKYCOrFatcaCrs;
};

export default {
    getEntityNeedConvenienceTest,
    getEntityNeedKYCOrFatcaCrs
};
